import { FC } from 'react';
import s from './profile-settings.module.css';
import { ProfileSettingsPush } from './profile-settings-push/profile-settings-push';

export const ProfileSettings: FC = () => {
  return (
    <div className={s.page}>
      {/* <ProfileSettingsLabel
        label={t('Email уведомления')}
        subLabel={t('Управляйте вашими уведомления по email')}
      >
        <Checkbox
          label={t('Отправлять мне уведомления')}
          subLabel={t('Включить отправку уведомлений от системы по электронной почте')}
        />
        <Checkbox
          label={t('Подписаться на новости')}
          subLabel={t('Включить уведомления о новостях сервиса')}
        />
      </ProfileSettingsLabel>
      <Divider /> */}
      <ProfileSettingsPush />

      {/* <Divider />
      <ProfileSettingsLabel
        label={t('История входа')}
        subLabel={t('Просмотрите Выше успешные входы в систему')}
      >
        <Table
          cols={{
            device: {
              label: t('Устройство'),
            },
            ip: {
              label: 'IP',
            },
            location: {
              label: t('Локация'),
            },
          }}
          rows={[
            {
              device: (
                <div className={s.device}>
                  <span className={s.name}>Trending mobile</span>
                  <span className={s.date}>January 24, 2023</span>
                </div>
              ),
              ip: '10.0.0.1',
              location: 'Астана, Казахстан',
            },
          ]}
        />
      </ProfileSettingsLabel> */}
    </div>
  );
};
